import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';

export type PhoneCountry = {
  /** 国家缩写码 */
  k: General.PhoneRegions;
  /** 国家名 */
  n: string;
  /** 手机号前面的国家码,国内手机号无 */
  ma: General.PhoneRegionCodes;
};

export default function usePhoneCountry() {
  const { t } = useTranslate();
  const pcArr: PhoneCountry[] = useMemo(
    () => [
      { k: 'cn', n: t('phoneCountry.cn'), ma: '+86' },
      { k: 'tw', n: t('phoneCountry.tw'), ma: '+886' },
      { k: 'hk', n: t('phoneCountry.hk'), ma: '+852' },
      { k: 'mo', n: t('phoneCountry.mo'), ma: '+853' },
      { k: 'us', n: t('phoneCountry.us'), ma: '+1' },
      { k: 'my', n: t('phoneCountry.my'), ma: '+60' },
      { k: 'id', n: t('phoneCountry.id'), ma: '+62' },
      { k: 'th', n: t('phoneCountry.th'), ma: '+66' },
      { k: 'ph', n: t('phoneCountry.ph'), ma: '+63' },
      { k: 'sg', n: t('phoneCountry.sg'), ma: '+65' },
      { k: 'vn', n: t('phoneCountry.vn'), ma: '+84' },
      { k: 'br', n: t('phoneCountry.br'), ma: '+55' },
      { k: 'mx', n: t('phoneCountry.mx'), ma: '+52' },
      { k: 'cl', n: t('phoneCountry.cl'), ma: '+56' },
      { k: 'ar', n: t('phoneCountry.ar'), ma: '+54' },
      { k: 'co', n: t('phoneCountry.co'), ma: '+57' },
      { k: 'fr', n: t('phoneCountry.fr'), ma: '+33' },
      { k: 'es', n: t('phoneCountry.es'), ma: '+34' },
      { k: 'pl', n: t('phoneCountry.pl'), ma: '+48' },
    ],
    [t],
  );
  return pcArr;
}
